"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var translateExtraInfo = function (core, msg, type) { return __awaiter(void 0, void 0, void 0, function () {
    var unwrapped, amount, address, cosmosSourceValidator, _a, cosmosAmount, cosmosAmount, cosmosAmount, validator;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = type;
                switch (_a) {
                    case "DELEGATE": return [3 /*break*/, 1];
                    case "UNDELEGATE": return [3 /*break*/, 6];
                    case "REWARD": return [3 /*break*/, 11];
                    case "REDELEGATE": return [3 /*break*/, 14];
                }
                return [3 /*break*/, 20];
            case 1: return [4 /*yield*/, core.CosmosLikeMessage.unwrapMsgDelegate(msg)];
            case 2:
                unwrapped = _b.sent();
                return [4 /*yield*/, unwrapped.getAmount()];
            case 3:
                cosmosAmount = _b.sent();
                return [4 /*yield*/, cosmosAmount.getAmount()];
            case 4:
                amount = _b.sent();
                return [4 /*yield*/, unwrapped.getValidatorAddress()];
            case 5:
                address = _b.sent();
                return [3 /*break*/, 20];
            case 6: return [4 /*yield*/, core.CosmosLikeMessage.unwrapMsgUndelegate(msg)];
            case 7:
                unwrapped = _b.sent();
                return [4 /*yield*/, unwrapped.getAmount()];
            case 8:
                cosmosAmount = _b.sent();
                return [4 /*yield*/, cosmosAmount.getAmount()];
            case 9:
                amount = _b.sent();
                return [4 /*yield*/, unwrapped.getValidatorAddress()];
            case 10:
                address = _b.sent();
                return [3 /*break*/, 20];
            case 11: return [4 /*yield*/, core.CosmosLikeMessage.unwrapMsgWithdrawDelegationReward(msg)];
            case 12:
                unwrapped =
                    _b.sent();
                return [4 /*yield*/, unwrapped.getValidatorAddress()];
            case 13:
                address = _b.sent();
                amount = new bignumber_js_1.BigNumber(0);
                return [3 /*break*/, 20];
            case 14: return [4 /*yield*/, core.CosmosLikeMessage.unwrapMsgBeginRedelegate(msg)];
            case 15:
                unwrapped = _b.sent();
                return [4 /*yield*/, unwrapped.getAmount()];
            case 16:
                cosmosAmount = _b.sent();
                return [4 /*yield*/, cosmosAmount.getAmount()];
            case 17:
                amount = _b.sent();
                return [4 /*yield*/, unwrapped.getValidatorDestinationAddress()];
            case 18:
                address = _b.sent();
                return [4 /*yield*/, unwrapped.getValidatorSourceAddress()];
            case 19:
                cosmosSourceValidator = _b.sent();
                return [2 /*return*/, {
                        validators: [
                            {
                                address: address,
                                amount: amount
                            },
                        ],
                        cosmosSourceValidator: cosmosSourceValidator
                    }];
            case 20:
                validator = {
                    address: address,
                    amount: amount
                };
                return [2 /*return*/, {
                        validators: [validator]
                    }];
        }
    });
}); };
function cosmosBuildOperation(_a) {
    var core = _a.core, coreOperation = _a.coreOperation;
    return __awaiter(this, void 0, void 0, function () {
        var cosmosLikeOperation, cosmosLikeTransaction, hash, memo, message, out, _b, _c, _d, _e, _f, _g, _h;
        var _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0: return [4 /*yield*/, coreOperation.asCosmosLikeOperation()];
                case 1:
                    cosmosLikeOperation = _k.sent();
                    return [4 /*yield*/, cosmosLikeOperation.getTransaction()];
                case 2:
                    cosmosLikeTransaction = _k.sent();
                    return [4 /*yield*/, cosmosLikeTransaction.getHash()];
                case 3:
                    hash = _k.sent();
                    return [4 /*yield*/, cosmosLikeTransaction.getMemo()];
                case 4:
                    memo = _k.sent();
                    return [4 /*yield*/, cosmosLikeOperation.getMessage()];
                case 5:
                    message = _k.sent();
                    out = {
                        hash: hash
                    };
                    return [4 /*yield*/, message.getRawMessageType()];
                case 6:
                    _b = _k.sent();
                    switch (_b) {
                        case "internal/MsgFees": return [3 /*break*/, 7];
                        case "cosmos-sdk/MsgDelegate": return [3 /*break*/, 8];
                        case "cosmos-sdk/MsgUndelegate": return [3 /*break*/, 10];
                        case "cosmos-sdk/MsgWithdrawDelegationReward": return [3 /*break*/, 12];
                        case "cosmos-sdk/MsgBeginRedelegate": return [3 /*break*/, 14];
                    }
                    return [3 /*break*/, 16];
                case 7:
                    out.type = "FEES";
                    return [3 /*break*/, 16];
                case 8:
                    out.type = "DELEGATE";
                    _c = out;
                    return [4 /*yield*/, translateExtraInfo(core, message, out.type)];
                case 9:
                    _c.extra = _k.sent();
                    return [3 /*break*/, 16];
                case 10:
                    out.type = "UNDELEGATE";
                    _d = out;
                    return [4 /*yield*/, translateExtraInfo(core, message, out.type)];
                case 11:
                    _d.extra = _k.sent();
                    return [3 /*break*/, 16];
                case 12:
                    out.type = "REWARD";
                    _e = out;
                    return [4 /*yield*/, translateExtraInfo(core, message, out.type)];
                case 13:
                    _e.extra = _k.sent();
                    return [3 /*break*/, 16];
                case 14:
                    out.type = "REDELEGATE";
                    _f = out;
                    return [4 /*yield*/, translateExtraInfo(core, message, out.type)];
                case 15:
                    _f.extra = _k.sent();
                    return [3 /*break*/, 16];
                case 16:
                    _g = out;
                    _h = [__assign({}, out.extra)];
                    _j = {};
                    return [4 /*yield*/, message.getIndex()];
                case 17:
                    _g.extra = __assign.apply(void 0, _h.concat([(_j.id = _k.sent(), _j)]));
                    if (memo) {
                        out.extra = __assign(__assign({}, out.extra), { memo: memo });
                    }
                    return [2 /*return*/, out];
            }
        });
    });
}
exports["default"] = cosmosBuildOperation;
//# sourceMappingURL=libcore-buildOperation.js.map